import { render } from "./Withdrawal.vue?vue&type=template&id=286b0ab4&scoped=true&ts=true"
import script from "./Withdrawal.vue?vue&type=script&lang=ts"
export * from "./Withdrawal.vue?vue&type=script&lang=ts"

import "./Withdrawal.vue?vue&type=style&index=0&id=286b0ab4&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286b0ab4"]])

export default __exports__